import React, { memo } from 'react'

import { FAQSectionTransport } from '@common/transports/deprecated-home-page-transport'
import PrimaryFAQs from './primary-faqs'
import SecondaryFAQs from './secondary-faqs'
import { Section, Title } from './faq-section-styles'
import { SectionContainer } from './common-styles'

interface Props {
    faqSection: FAQSectionTransport
}

const FAQSection: React.FC<Props> = ({
    faqSection: { id, title, primary: primaryFAQs, secondary: secondaryFAQs, showMoreText, secondaryFAQVisibleCount },
}) => (
    <SectionContainer id={id}>
        <Section>
            <Title>{title}</Title>
            {!!primaryFAQs && primaryFAQs.length > 0 && <PrimaryFAQs primaryFAQs={primaryFAQs} />}
            <SecondaryFAQs
                secondaryFAQs={secondaryFAQs}
                showMoreText={showMoreText}
                secondaryFAQVisibleCount={secondaryFAQVisibleCount}
            />
        </Section>
    </SectionContainer>
)

export default memo(FAQSection)
